import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, Container, Typography, Accordion, AccordionSummary, AccordionDetails, useTheme } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { SectionHeader } from './sectionHeader';
import { SectionBox } from './sectionBox';
export const FAQSection = ({ title, subtitle, faqs, defaultExpanded = 0, }) => {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(`faq-${defaultExpanded}`);
    const handleChange = (panel) => (_event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (_jsx(SectionBox, { background: theme.palette.background.paper, id: "faq", children: _jsxs(Container, { maxWidth: "md", sx: { px: { xs: 4, md: 6 } }, children: [_jsx(SectionHeader, { title: title, subtitle: subtitle }), _jsx(Box, { sx: {
                        '& .MuiAccordion-root': {
                            backgroundColor: theme.palette.background.paper,
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: '6px !important',
                            mb: 4,
                            boxShadow: 'none',
                            '&:before': { display: 'none' },
                            '&.Mui-expanded': {
                                borderColor: theme.palette.primary.main,
                                boxShadow: `0 4px 20px ${theme.palette.primary.main}15`
                            }
                        },
                        '& .MuiAccordionSummary-root': {
                            minHeight: 64,
                            px: 6,
                            '&.Mui-expanded': {
                                minHeight: 64,
                            }
                        },
                        '& .MuiAccordionSummary-content': {
                            my: 4,
                            '&.Mui-expanded': {
                                my: 4,
                            }
                        },
                        '& .MuiAccordionDetails-root': {
                            px: 6,
                            pb: 6,
                        }
                    }, children: faqs.map((faq, index) => (_jsxs(Accordion, { expanded: expanded === `faq-${index}`, onChange: handleChange(`faq-${index}`), children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { sx: {
                                        color: expanded === `faq-${index}` ? theme.palette.primary.main : theme.palette.text.secondary,
                                        transition: 'color 0.2s ease'
                                    } }), children: _jsx(Typography, { sx: {
                                        fontWeight: 600,
                                        color: expanded === `faq-${index}` ? theme.palette.primary.main : theme.palette.text.primary,
                                        fontSize: '16px',
                                        transition: 'color 0.2s ease',
                                        pr: 4
                                    }, children: faq.question }) }), _jsx(AccordionDetails, { children: _jsx(Typography, { sx: {
                                        color: theme.palette.text.secondary,
                                        lineHeight: 1.7,
                                        fontSize: '15px'
                                    }, children: faq.answer }) })] }, index))) })] }) }));
};
